import { render, staticRenderFns } from "./GridDisplay.vue?vue&type=template&id=430f23e6&scoped=true&"
import script from "./GridDisplay.vue?vue&type=script&lang=js&"
export * from "./GridDisplay.vue?vue&type=script&lang=js&"
import style0 from "./GridDisplay.vue?vue&type=style&index=0&id=430f23e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430f23e6",
  null
  
)

export default component.exports